import * as React from "react";

function Landing({ text, image, button, imagePosition = "center" }) {
  const [isMobile, setIsMobile] = React.useState(window.innerWidth < 768);

  React.useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <div className="flex flex-col justify-center w-full text-white ">
      <div className={`flex overflow-hidden relative flex-col items-center px-16 pb-14 w-full banner_container lg:min-h-[calc(100vh-100px)] max-md:px-5 max-md:max-w-full ${imagePosition === "top" ? "pt-16" : "pt-6"}`}>
        <img
          loading="lazy"
          src={`${image}`}
          alt="Background"
          // add little  darkness to the background so that text should visible clearly
          style={{ filter: "brightness(50%)" }}
          className={`absolute inset-0 object-cover size-full ${imagePosition === "top" ? "object-top" : ""}`}
        />
        {text && <h5 className={`absolute font-bold ${isMobile ? 'text-4xl' : 'text-6xl'}  text-left text-white bottom-[25%] left-[10%] whitespace-pre-line uppercase !leading-[1.3]`}>{text || ""}</h5>}
        {Object.keys(button || {})?.length > 0 && <button onClick={button?.action} className="absolute bottom-[10%] left-[10%] bg-[#1C486B] rounded-[8px] py-3 px-4 font-[600] flex flex-row items-center gap-2">{button?.text} {button?.icon}</button>}
      </div>
    </div>
  );
}

export default Landing;
